
import UtilCache from '../../cache';
import routerNameMap from './routerNameMap';
export default {
    computed: {
        pageAuth () {
            const routerName = this.$route.name;
            if (routerNameMap[routerName]) {
                const subRouterNameList = routerNameMap[routerName];
                return {
                    ...permissions.global,
                    ...subRouterNameList[0],
                    func: subRouterNameList.reduce((res, item) => ({...res, ...item.func}), {}),
                };
            }
            const permissions = UtilCache.getLocalItem('permissions');
            const metaAuth = this.$route.meta?.auth;
            if (permissions[metaAuth]) {
                return {
                    ...permissions.global,
                    ...permissions[metaAuth],
                };
            }
            return {
                ...permissions.global,
                ...permissions[routerName],
            };
        },
        pageAuthFunc () {
            return this.pageAuth.func.reduce((res, item) => ({...res, [item]: true}), {});
        },
        pageAuthDict () {
            // console.log(this.pageAuth);
            const baseConfig = UtilCache.getLocalItem('baseConfig');
            let gameList = baseConfig.games;
            let regionList = baseConfig.regions;
            let spreaderList = baseConfig.spreaders;
            let packageList = baseConfig.packages;
            if (!this.isAuthListAll(this.pageAuth.game || ['*'])) {
                gameList = gameList.filter(i => this.pageAuth.game.includes(i.game_id + ''));
            }
            if (!this.isAuthListAll(this.pageAuth.region || ['*'])) {
                regionList = regionList.filter(i => this.pageAuth.region.includes(i.id + ''));
                packageList = packageList.filter(i => this.pageAuth.region.includes(i.region_id + ''));
            }
            if (!this.isAuthListAll(this.pageAuth.spreader || ['*'])) {
                spreaderList = spreaderList.filter(i => this.pageAuth.spreader.includes(i.spreader_id + ''));
            }
            if (!this.isAuthListAll(this.pageAuth.app || ['*'])) {
                packageList = packageList.filter(i => this.pageAuth.app.includes(i.app_id + ''));
            }
            return {gameList, regionList, spreaderList, packageList };
        },
    },
    methods: {
        isAuthListAll (list) {
            return Array.isArray(list) && list.includes('*');
        }
    }

};
